module.exports = __webpack_public_path__ + "img/img3.c5f66066.jpg";